import styled from 'styled-components';

import { ActionLink } from 'components/action-button';
import { ModalContent } from 'components/modal';
import { primitive } from 'styles/constants/primitives';

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-block-start: ${primitive.$spacing4};
  margin-block-end: ${primitive.$spacing4};
  width: 100%;
`;

export const ContentText = styled.p`
  color: ${Styles.color.black};
  font: var(--font-copyOne);
  text-align: center;
  margin: 0;

  &:not(:last-of-type) {
    margin-block-end: ${primitive.$spacing6};
  }
`;

export const StyledActionLink = styled(ActionLink)`
  ${Styles.mobile} {
    font-size: 1.1rem;
  }

  &:not(:last-of-type) {
    margin-block-end: ${primitive.$spacing4};
  }
`;

export const StyledModalContent = styled(ModalContent)`
  .modal-inner {
    ${Styles.mobile} {
      height: 100%;
    }
  }
`;

export const Title = styled.h1`
  margin-block-start: ${primitive.$spacing2};
  margin-block-end: ${primitive.$spacing7};
  font: var(--font-headerOne);
`;

export const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;
  margin-block-end: ${primitive.$spacing3};
`;

export const SubTitle = styled.h2`
  font: var(--font-headerTwo);
  line-height: 0px;
  margin: 0;
  margin-inline-end: ${primitive.$spacing1};
`;

export const ModalBodyContainer = styled.div`
  padding: 0 2.5rem;

  ${Styles.mobile} {
    flex: 1;
    padding: 0;
  }
`;
